const TABLE = {
  ACTION_TYPE: {
    ADD: 'add',
    VIEW: 'view',
    EDIT: 'edit',
    DELETE: 'delete',
    COPY: 'copy',
    EXTERNAL: 'external',
    ARCHIVE: 'archive',
    TOGGLE: 'toggle',
    CHART: 'chart'
  },
};

export const COMPONENT = {
  TABLE,
};
